import React, { useEffect } from 'react';

const AdUnit = () => {
  useEffect(() => {
    // Push the ad since AdSense script is already loaded globally
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error('AdSense ad push error:', e);
    }
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '10px 0',
      minHeight: '90px', // Reserve space for ad
      background: 'rgba(255, 255, 255, 0.05)', // Subtle background for visibility
      borderRadius: '8px',
      padding: '10px',
      width: '100%'
    }}>
      <ins
        className="adsbygoogle"
        style={{
          display: 'block',
          width: '100%',
          maxWidth: '728px',
          height: '90px'
        }}
        data-ad-client="ca-pub-6000413615734105"
        data-ad-slot="2153108226"
        data-ad-format="horizontal"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdUnit;
